import { render } from "./EvidenceTableInput.vue?vue&type=template&id=36a1953d"
import script from "./EvidenceTableInput.vue?vue&type=script&lang=js"
export * from "./EvidenceTableInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__